import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import getLang from 'I18n/utils/getLang';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import MarketingNavHeader from 'ecosystem-marketplace-core/components/nav/MarketingNavHeader';
import MarketingNavFooter from 'ecosystem-marketplace-core/components/nav/MarketingNavFooter';
import { useWindowDimensionsContext } from 'ecosystem-marketplace-core/hooks/useWindowDimensionsContext';
import { getCmsHubPricingUrl, getFullPublicUrl } from '../utils/urls';
const GRID_BREAKPOINT_MEDIUM_INT = parseInt(GRID_BREAKPOINT_MEDIUM, 10);
const languagesContent = {
  en: ['English'],
  jp: ['日本語'],
  de: ['Deutsch'],
  es: ['Español'],
  pt: ['Português'],
  fr: ['Français']
};
export default function App({
  children
}) {
  const lang = getLang();
  const hydratedLanguagesContent = useMemo(() => {
    return Object.keys(languagesContent).reduce((final, key) => {
      return Object.assign({}, final, {
        [key]: languagesContent[key].concat([getFullPublicUrl(key), ''])
      });
    }, {});
  }, []);
  const headerContentBlob = useMemo(() => {
    return {
      upperNavContent: {
        homeUrl: getFullPublicUrl(lang),
        regionalDropdownContent: {
          languagesContent: hydratedLanguagesContent
        }
      },
      mobileNavContent: {
        languagesContent: hydratedLanguagesContent
      },
      navCta: {
        navCtaUrl: getCmsHubPricingUrl()
      }
    };
  }, [hydratedLanguagesContent, lang]);
  const {
    width: windowWidth
  } = useWindowDimensionsContext();
  const headerVariation = windowWidth < GRID_BREAKPOINT_MEDIUM_INT ? 'default' : 'marketplace';
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "stretch",
    "data-test-id": "app",
    direction: "column",
    style: {
      minHeight: '100vh'
    },
    children: [/*#__PURE__*/_jsx(MarketingNavHeader, {
      contentBlob: headerContentBlob,
      enableConvertFlag: true,
      lang: lang,
      variation: headerVariation
    }), /*#__PURE__*/_jsx(UIBox, {
      grow: 1,
      shrink: 1,
      children: children
    }), /*#__PURE__*/_jsx(MarketingNavFooter, {
      lang: lang
    })]
  });
}